// save token with expiry (e.g., 1 hour)
export function saveToken(token) {
    const expiryTime = Date.now() + 5 * 60 * 60 * 1000; // 1 hour
    localStorage.setItem("token", token);
    localStorage.setItem("token_expiry", expiryTime.toString());
};

export function removeToken() {
  localStorage.removeItem('token');
  localStorage.removeItem('token_expiry');
};

  
export function getToken(){
    const token = localStorage.getItem("token");
    const expiry = localStorage.getItem("token_expiry");
  
    if (!token || !expiry) return null;
    if (Date.now() > Number(expiry)) {
      // Token expired
      localStorage.removeItem("token");
      localStorage.removeItem("token_expiry");
      return null;
    }
    return token;
};

export function getApiBaseUrl() {
  const configuredUrl = (process.env.REACT_APP_API_URL || "").trim();

  if (configuredUrl) {
    return configuredUrl.replace(/\/+$/, "");
  }

  if (typeof window !== "undefined" && window.location.hostname !== "localhost") {
    return `${window.location.origin}/api`;
  }

  return "http://localhost:8000";
}
  
